import { render, staticRenderFns } from "./layouts.policy.b4fc97a6.vue?vue&type=template&id=7b7753f4"
import script from "./layouts.policy.b4fc97a6.vue?vue&type=script&lang=js"
export * from "./layouts.policy.b4fc97a6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports